export default `<svg width="146" height="123" viewBox="0 0 146 123" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M145.274 4.54348L75.5725 120.713C74.4073 122.655 71.5927 122.655 70.4275 120.713L35.5 62.5L0.726092 4.54349C-0.473652 2.54391 0.966686 0 3.29857 0H142.701C145.033 0 146.474 2.54391 145.274 4.54348Z" fill="currentColor"/>
</svg>
`